export default __webpack_public_path__ + "static/media/logo-ume-surrey.34c178a2.png";